export const FullLegend = () => (
  <div className="absolute bottom-auto left-5 top-32 z-10 rounded bg-[#171717]/80 p-4 sm:bottom-4 sm:left-2 sm:top-auto md:bottom-10 md:left-5">
    <div className="mb-2 flex items-center">
      <div
        className="mr-2 h-3 w-3 rounded-full"
        style={{
          backgroundColor: "rgba(255, 215, 251, 0.3)",
          border: "1px solid rgb(255, 226, 252)",
        }}
      />
      <span className="text-xs uppercase text-white md:text-sm">Public Schools</span>
    </div>
    <div className="mb-4 flex items-center">
      <div
        className="mr-2 h-3 w-3 rounded-full"
        style={{
          backgroundColor: "rgba(239, 183, 79, 0.3)",
          border: "1px solid rgb(239, 183, 79)",
        }}
      />
      <span className="text-xs uppercase text-white md:text-sm">Private Schools</span>
    </div>

    <div className="mb-2 text-sm uppercase text-white">Shade</div>
    <div className="flex items-center">
      <span className="mr-2 text-xs text-white">0</span>
      <div
        className="h-4 flex-grow"
        style={{
          background: "linear-gradient(to right, #F6D0B1, #C2CAD4, #8B929E, #47505F)",
        }}
      />
      <span className="ml-2 text-xs text-white">&gt;50%</span>
    </div>
  </div>
)

export const ShadeLegend = () => (
  <div
    className="absolute bottom-auto left-5 top-20 z-10 rounded bg-[#171717]/80 p-4 sm:bottom-4 sm:left-2 sm:top-auto md:bottom-10 md:left-5"
    style={{ minWidth: "173px" }}
  >
    <div className="mb-2 text-sm uppercase text-white">Shade</div>
    <div className="flex items-center">
      <span className="mr-2 text-xs text-white">0</span>
      <div
        className="h-4 flex-grow"
        style={{
          background: "linear-gradient(to right, #F6D0B1, #C2CAD4, #8B929E, #47505F)",
        }}
      />
      <span className="ml-2 text-xs text-white">&#8250;50%</span>
    </div>
  </div>
)
